"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevertToDefaultLabelDialog = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_query_1 = require("@tanstack/react-query");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelHelpers_1 = require("./LabelHelpers");
const labelValues_1 = require("./restApi/labelValues");
const LabelType_1 = require("./shared/LabelType");
const revertToDefaultLabelTestId = 'Edit-Label';
const queryKey = [revertToDefaultLabelTestId];
function RevertToDefaultLabelDialog({ labelValue, category, hideDialog, getAnchorClientRect }) {
    const queryClient = (0, react_query_1.useQueryClient)();
    const mutationFn = (0, catalog_core_1.useRestFn)(labelValues_1.deleteLabelValue);
    const body = react_1.default.createElement(react_1.default.Fragment, null, catalog_messages_1.Messages.RevertToDefaultLabelActionMessage());
    const submit = (0, react_query_1.useMutation)({
        mutationFn,
        onSettled: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield queryClient.invalidateQueries({ queryKey });
            hideDialog();
        }),
        onSuccess: () => widgets_1.ToastWidget.show({
            message: catalog_messages_1.Messages.RevertToDefaultLabelToastSuccess({
                LABEL_CATEGORY: (0, LabelHelpers_1.localizeLabelCategory)(category),
                LABEL_VALUE: (0, LabelType_1.localizeLabelValueName)(labelValue),
            }),
            toastType: widgets_1.ToastType.Success,
            testId: 'revert-to-default-label-success',
        }),
        onError: () => {
            widgets_1.ToastWidget.show({
                message: catalog_messages_1.Messages.ErrorWithoutErrorCode(),
                toastType: widgets_1.ToastType.Error,
                testId: 'revert-to-default-label-error',
            });
        },
    });
    const dialogProps = {
        showCloseButton: true,
        isModal: true,
        type: widgets_1.DialogType.NormalWithTitleBar,
        positioningBehavior: widgets_1.DialogPositioningBehavior.Draggable,
        userResizeMode: widgets_1.DialogUserResizeMode.Horizontal,
        dialogWidth: 400,
        dialogBodyStyle: {
            paddingBottom: 8,
        },
        onCloseRequest: hideDialog,
        handleGlassClick: hideDialog,
        getAnchorClientRect: getAnchorClientRect,
        title: catalog_messages_1.Messages.RevertToDefaultLabelDialogTitle(),
        testId: 'revert-to-default-label-dialog',
        footerContent: (react_1.default.createElement(widgets_1.DialogFooterButtonsWidget, { buttons: [
                { buttonType: widgets_1.ButtonType.Outline, onClick: hideDialog, children: catalog_messages_1.Messages.Cancel() },
                {
                    buttonType: widgets_1.ButtonType.Destructive,
                    onClick: () => submit.mutate({ existingValueName: labelValue }),
                    children: catalog_messages_1.Messages.RevertAction(),
                },
            ] })),
    };
    return (react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, dialogProps), body));
}
exports.RevertToDefaultLabelDialog = RevertToDefaultLabelDialog;
//# sourceMappingURL=RevertToDefaultLabelDialog.js.map